import React, { useState, useEffect } from 'react'
import { ReactSortable } from 'react-sortablejs'
import { notRepeatingShuffleForRank } from '../utils/SmartLabelUtils'
import 'katex/dist/katex.min.css'
import { KnovaText } from '../BasicUIComponents/KnovaText'

function SCRearrange(props) {
  const {
    isPractice,
    Completed,
    isActive,
    componentData,
    themeColors,
    themeFont,
    themeStyles,
    isSideMenu,
    isFollowTheFlow,
    priorityActive,
    isAudioPlaying,
    isReplaying
  } = props
  const { defaultValue, onValueChange, onPriorityChange } = props
  const { ControlID, Score, Options, Priority } = componentData

  const [sortedRankValueArray, setSortedRankValueArray] = useState([])
  const [sentence, setSentence] = useState([])
  const [initial, setInitial] = useState(true)
  const [selectedOption, setSelectedOption] = useState('')

  useEffect(() => {
    let sentenceCopy = []
    for (let i = 0; i < Options.length; i++) {
      sentenceCopy.push(Options[i])
    }
    setSentence(sentenceCopy)
    if (defaultValue) {
      let defaultValueSelected = defaultValue.CtlValue
      setSortedRankValueArray(defaultValueSelected)
      setInitial(false)
    } else {
      setSortedRankValueArray(notRepeatingShuffleForRank(Options))
    }
  }, [defaultValue])

  function handleOptionChange() {
    if (selectedOption && selectedOption !== '') {
      const selectedIndex = sortedRankValueArray.findIndex(
        (answer) => answer.Option === selectedOption
      )
      const correctAnswerIndex = Options.findIndex(
        (answer) => answer.Option === selectedOption
      )
      setSelectedOption('')
    }
    validateCorrectAnswer()
  }

  function validateCorrectAnswer(timerValue) {
    let sortedRankValueArrayCopy = []
    let sentenceArrayCopy = []
    for (let index = 0; index < sortedRankValueArray.length; index++) {
      sortedRankValueArrayCopy.push({
        Option: sortedRankValueArray[index].Option
      })
    }
    for (let index = 0; index < sentence.length; index++) {
      sentenceArrayCopy.push({
        Option: sentence[index].Option
      })
    }
    if (
      JSON.stringify(sentenceArrayCopy) ===
      JSON.stringify(sortedRankValueArrayCopy)
    ) {
      onValueChange(
        ControlID,
        sortedRankValueArray,
        Score,
        Score,
        '',
        timerValue
      )
      onPriorityChange(Priority)
    } else {
      onValueChange(ControlID, sortedRankValueArray, 0, Score, '', timerValue)
    }
  }
  return (
    <div
      className='sc-arrange-cont'
      style={{
        filter: isFollowTheFlow
          ? Priority <= priorityActive
            ? 'unset'
            : 'blur(3px)'
          : 'unset',
        pointerEvents:
          Completed === 1 || !isActive || isAudioPlaying || isReplaying
            ? 'none'
            : isFollowTheFlow
            ? isPractice
              ? Priority === priorityActive
                ? 'auto'
                : 'none'
              : Priority > priorityActive
              ? 'none'
              : 'auto'
            : 'auto'
      }}
    >
      <ReactSortable
        className='sc-rank-sort-cont'
        style={{ gap: isSideMenu ? '8px' : '19px' }}
        list={sortedRankValueArray}
        setList={(sortList) => {
          setSortedRankValueArray(sortList)
        }}
        swap={true}
        onEnd={() => handleOptionChange()}
      >
        {sortedRankValueArray.map((item, index) => (
          <div
            key={'scarrange' + index}
            className='arrange-option-style'
            onMouseDown={() => {
              setSelectedOption(item.Option)
            }}
          >
            <KnovaText
              contBgColor={
                isPractice || Completed === 1 || !isActive
                  ? selectedOption && selectedOption === item.Option
                    ? themeColors.primary
                    : initial
                    ? themeColors.surfaceVarient
                    : Options[index].Option === item.Option
                    ? themeColors.successContainer
                    : themeColors.errorContainer
                  : initial
                  ? themeColors.surfaceVarient
                  : themeStyles.selectionColor
              }
              contPadding={isSideMenu ? '2px' : '16px 24px'}
              contBorderColor={
                isPractice || Completed === 1 || !isActive
                  ? initial
                    ? themeColors.outline
                    : selectedOption && selectedOption === item.Option
                    ? themeColors.outlineVarient
                    : Options[index].Option === item.Option
                    ? themeColors.success
                    : themeColors.error
                  : initial
                  ? themeColors.outline
                  : themeColors.outlineVarient
              }
              contBorderWidth='2px'
              contBorderRadius={isSideMenu ? '6px' : '12px'}
              text={item.Option}
              textColor={
                isPractice || Completed === 1 || !isActive
                  ? initial
                    ? themeColors.onSurfaceVarient
                    : selectedOption && selectedOption === item.Option
                    ? themeColors.onPrimary
                    : Options[index].Option === item.Option
                    ? themeColors.onSuccess
                    : themeColors.onError
                  : initial
                  ? themeColors.onSurfaceVarient
                  : themeStyles.selectionTextColor
              }
              textFontSize={isSideMenu ? '5px' : '16px'}
              textFontFamily={themeFont.bodyFont}
              textFontWeight={initial ? '400' : '700'}
              textAlign='center'
              cursor='move'
              isIcon={true}
              iconName={'drag'}
              iconPosition='start'
              iconColor={
                initial ? themeColors.onSurfaceVarient : themeColors.onError
              }
              isSideMenu={isSideMenu}
            />
          </div>
        ))}
      </ReactSortable>
    </div>
  )
}

export default SCRearrange
